import { useLensApp } from "../useLensApp.jsx";
import FavoritesShelf from "./FavoritesShelf.jsx";
import CameraSection from "./CameraSection.jsx";
import OutputSection from "./OutputSection.jsx";
import LensToggleSection from "./LensToggleSection.jsx";

export default function SettingsPanel() {
  const { settingsCollapsed, actions } = useLensApp();
  const collapsedLabel = settingsCollapsed ? "Expand settings" : "Collapse settings";

  return (
    <aside>
      <div className="panel-title">
        <h2>Settings</h2>
        <div className="panel-title-actions">
          <button
            className="panel-refresh"
            title="Refresh cameras"
            onClick={() => actions.enumerateCameras().catch(actions.setError)}
          >
            Refresh
          </button>
          <button
            className="icon-button"
            type="button"
            title={collapsedLabel}
            aria-label={collapsedLabel}
            aria-expanded={!settingsCollapsed}
            onClick={() => actions.toggleSettingsCollapsed().catch(actions.setError)}
          >
            {settingsCollapsed ? "<" : ">"}
          </button>
        </div>
      </div>
      <div className="panel-scroll">
        <LensToggleSection />
        <FavoritesShelf />
        <CameraSection />
        <OutputSection />
      </div>
    </aside>
  );
}
